export default "__VITE_ASSET__Bj8ev90m__"